export default "__VITE_ASSET__5QWJMtfa__"